import { reducerHyperlinkActions } from './hyperlink.reducer';
import * as actionImport from './hyperlink.actions';
export { default } from './hyperlink.reducer';

export const hyperlinkActions = { ...reducerHyperlinkActions, ...actionImport };
